import { Stack, Text, Group, Box, UnstyledButton } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import classes from './ModelsModal.module.css';
import { AVAILABLE_MODELS, normalizeSelectedModel, type Model } from '../../../../config/models';

interface ModelsModalProps {
  selectedModel?: string;
  onModelSelect?: (model: Model) => void;
}

export const ModelsModal = ({ selectedModel, onModelSelect }: ModelsModalProps) => {
  const normalizedSelectedModel = normalizeSelectedModel(selectedModel);

  const handleModelClick = (model: Model) => {
    onModelSelect?.(model);
  };

  return (
    <Box className={classes.modal}>
      <Box className={classes.sectionHeader}>
        <Text className={classes.sectionTitle}>Models</Text>
      </Box>

      <Stack gap={0} className={classes.modelList}>
        {AVAILABLE_MODELS.map((model) => (
          <UnstyledButton
            key={model.id}
            className={classes.modelItem}
            onClick={() => handleModelClick(model)}
          >
            <Group gap={9} align="center" justify="space-between">
              <Box className={classes.modelContent}>
                <Text className={classes.modelName}>{model.name}</Text>
                <Text className={classes.modelDescription}>{model.description}</Text>
              </Box>
              {normalizedSelectedModel === model.id && (
                <Box className={classes.checkIcon}>
                  <IconCheck size={20} color="#59B836" />
                </Box>
              )}
            </Group>
          </UnstyledButton>
        ))}
      </Stack>
    </Box>
  );
};

export type { Model, ModelsModalProps };
